import { ReturnTypeEnum } from "@redotech/redo-return-core-common/return-type-enum";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const updateBundleAllowedReturnTypes = {
  name: "updateBundleAllowedReturnTypes" as const,
  input: z.object({
    parentVariantId: z.string(),
    allowedTypes: z.array(createEnum(ReturnTypeEnum)),
  }),
  output: z.object({ allowedTypes: z.array(createEnum(ReturnTypeEnum)) }),
};
